// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__27huX","content":"Consent_content__3wTTD","footer":"Consent_footer__DJ2b3"};